import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type LocalizationFlatTeamSettingGroupId = "localization.general";

const owner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.localization",
  product: "general",
};

const risk: SettingRisk = {
  level: "medium",
  reason: "Changes the language shoppers see across the customer portal.",
};

export const LocalizationFlatTeamSettingGroups = [
  {
    id: "localization.general",
    title: "Localization",
    description:
      "Whether Redo serves translated copy to shoppers, driving the locale provider in the customer portal and merchant app.",
    productArea: "general",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner,
    risk,
    agentEditability: { mode: "requiresApproval" },
    synonyms: ["localization", "translations", "languages"],
  },
] as const satisfies readonly SettingGroupDefinition<LocalizationFlatTeamSettingGroupId>[];

export const LocalizationFlatTeamSettingGroupById = (() => {
  const map: Record<
    string,
    SettingGroupDefinition<LocalizationFlatTeamSettingGroupId>
  > = {};
  for (const group of LocalizationFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  return map as Record<
    LocalizationFlatTeamSettingGroupId,
    SettingGroupDefinition<LocalizationFlatTeamSettingGroupId>
  >;
})();
